/**
 *
 */
export function find<T>(
    array: T[],
    callback: (e: T, i?: number, array?: T[]) => boolean,
    thisArg?: any
) {
    for (let i = 0; i < array.length; i++) {
        if (callback.call(thisArg, array[i], i, array)) {
            return array[i]
        }
    }

    return undefined
}

/**
 *
 */
export function findIndex<T>(
    array: T[],
    callback: (e: T, i?: number, array?: T[]) => boolean,
    thisArg?: any
) {
    for (let i = 0; i < array.length; i++) {
        if (callback.call(thisArg, array[i], i, array)) {
            return i
        }
    }

    return undefined
}

/**
 * Splits an array into sets, grouped by the value returned by the callback.
 * Returns an array of tuple of group key and item array
 */
export function groupBy<T>(
    array: T[],
    callback: (e: T, i?: number, array?: T[]) => string,
    thisArg?: any
) {
    const results: [string, T[]][] = []
    const idxMap: { [key: string]: number } = {}
    for (let i = 0; i < array.length; i++) {
        const key = callback.call(thisArg, array[i], i, array)
        if (idxMap[key] === undefined) {
            results.push([key, [array[i]]])
            idxMap[key] = results.length - 1
        } else {
            results[idxMap[key]][1].push(array[i])
        }
    }
    return results
}

/**
 *
 */
export function contains<T>(arr: T[], obj: T) {
    return arr.indexOf(obj) >= 0
}

export function insert(arr: any[], index: number, newItem: any) {
    return [...arr.slice(0, index), newItem, ...arr.slice(index)]
}

/**
 *
 */
export function remove<T>(arr: T[], obj: T) {
    const idx = arr.indexOf(obj)
    if (idx >= 0) {
        arr.splice(idx, 1)
    }
    return idx >= 0
}

/**
 *
 */
export function flatten<T>(arr: T[][]): T[] {
    return arr.reduce((prev, cur) => prev.concat(cur), [])
}
